import { lazy } from 'react';

// project-imports
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
// const DashboardAnalytics = Loadable(lazy(() => import('pages/dashboard/analytics')));

// render - actors
const SubAdmin = Loadable(lazy(() => import('pages/sub-admin/sub-admin')));
const AddEditSubAdmin = Loadable(lazy(() => import('pages/sub-admin/manage')));
const Vendor = Loadable(lazy(() => import('pages/vendor/vendor')));
const AddEditVendor = Loadable(lazy(() => import('pages/vendor/manage')));
const Franchise = Loadable(lazy(() => import('pages/franchise/franchise')));
const AddEditFranchise = Loadable(lazy(() => import('pages/franchise/manage')));
const Request = Loadable(lazy(() => import('pages/request/list')));
const ReturnRequest = Loadable(lazy(() => import('pages/request/return-request')));
const Wheelz = Loadable(lazy(() => import('pages/wheelz/wheelz')));
const AddEditWheelz = Loadable(lazy(() => import('pages/wheelz/manage')));
const Reason = Loadable(lazy(() => import('pages/return/reason')));
const AddEditReason = Loadable(lazy(() => import('pages/return/manage')));
const Checklist = Loadable(lazy(() => import('pages/checklist/checklist')));
const AddEditChecklist = Loadable(lazy(() => import('pages/checklist/manage')));
const FAQ = Loadable(lazy(() => import('pages/faq/faq')));
const AddEditFAQ = Loadable(lazy(() => import('pages/faq/manage')));
const Earnings = Loadable(lazy(() => import('pages/earnings/earnings')));
const PartnersEarnings = Loadable(lazy(() => import('pages/earnings/partners-earnings')));

// render - order
const Order = Loadable(lazy(() => import('pages/apps/order/order-data')));
const Return = Loadable(lazy(() => import('pages/apps/order/return-list')));

// render - widget
const WidgetStatistics = Loadable(lazy(() => import('pages/widget/statistics')));
// const WidgetData = Loadable(lazy(() => import('pages/widget/data')));
const WidgetChart = Loadable(lazy(() => import('pages/widget/chart')));

// render - applications
const AppChat = Loadable(lazy(() => import('pages/apps/chat')));
const AppCalendar = Loadable(lazy(() => import('pages/apps/calendar')));

const AppKanban = Loadable(lazy(() => import('pages/apps/kanban')));
const AppKanbanBacklogs = Loadable(lazy(() => import('sections/apps/kanban/Backlogs')));
const AppKanbanBoard = Loadable(lazy(() => import('sections/apps/kanban/Board')));

const AppCustomerList = Loadable(lazy(() => import('pages/apps/customer/list')));
const AppCustomerCard = Loadable(lazy(() => import('pages/apps/customer/card')));
const AppCustomerEdit = Loadable(lazy(() => import('pages/apps/customer/edit-customer')));

const AppInvoiceCreate = Loadable(lazy(() => import('pages/apps/invoice/create')));
const AppInvoiceDashboard = Loadable(lazy(() => import('pages/apps/invoice/dashboard')));
const AppInvoiceList = Loadable(lazy(() => import('pages/apps/invoice/list')));
const AppInvoiceDetails = Loadable(lazy(() => import('pages/apps/invoice/details')));
const AppInvoiceEdit = Loadable(lazy(() => import('pages/apps/invoice/edit')));

const UserProfile = Loadable(lazy(() => import('pages/apps/profiles/user')));
const UserTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/user/TabPersonal')));
const UserTabPayment = Loadable(lazy(() => import('sections/apps/profiles/user/TabPayment')));
const UserTabPassword = Loadable(lazy(() => import('sections/apps/profiles/user/TabPassword')));
const UserTabSettings = Loadable(lazy(() => import('sections/apps/profiles/user/TabSettings')));

const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
const AccountTabProfile = Loadable(lazy(() => import('sections/apps/profiles/account/TabProfile')));
const AccountTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/account/TabPersonal')));
const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));
const AccountTabRole = Loadable(lazy(() => import('sections/apps/profiles/account/TabRole')));
const AccountTabSettings = Loadable(lazy(() => import('sections/apps/profiles/account/TabSettings')));

const ProductCategory = Loadable(lazy(() => import('pages/apps/category/category-list')));
const ProductAddCategory = Loadable(lazy(() => import('pages/apps/category/add-category')));
const ProductSubcategory = Loadable(lazy(() => import('pages/apps/category/subcategory-list')));
const ProductAddSubcategory = Loadable(lazy(() => import('pages/apps/category/add-subcategory')));
const ProductType = Loadable(lazy(() => import('pages/apps/category/productType-list')));
const AddProductType = Loadable(lazy(() => import('pages/apps/category/add-productType')));
const Variant = Loadable(lazy(() => import('pages/apps/attribute/attribute-list')));
const AddVariant = Loadable(lazy(() => import('pages/apps/attribute/add-attribute')));
const VariantValue = Loadable(lazy(() => import('pages/apps/attribute/attributeValue-list')));
const AddVariantValue = Loadable(lazy(() => import('pages/apps/attribute/add-attributeValue')));
const State = Loadable(lazy(() => import('pages/apps/location/state-list')));
const AddState = Loadable(lazy(() => import('pages/apps/location/add-state')));
const City = Loadable(lazy(() => import('pages/apps/location/city-list')));
const AddCity = Loadable(lazy(() => import('pages/apps/location/add-city')));
const Taxes = Loadable(lazy(() => import('pages/apps/taxes/list-tax')));
const Charges = Loadable(lazy(() => import('pages/apps/charges/list')));
const AddCharge = Loadable(lazy(() => import('pages/apps/charges/manage')));
const AddTax = Loadable(lazy(() => import('pages/apps/taxes/add-tax')));
const Notifications = Loadable(lazy(() => import('pages/apps/notifications/notifications')));

const AppECommProducts = Loadable(lazy(() => import('pages/apps/e-commerce/product')));
const AppECommProductDetails = Loadable(lazy(() => import('pages/apps/e-commerce/product-details')));
const AppECommProductList = Loadable(lazy(() => import('pages/apps/e-commerce/products-list')));
// const AppECommCheckout = Loadable(lazy(() => import('pages/apps/e-commerce/checkout')));
// const AppECommAddProduct = Loadable(lazy(() => import('pages/apps/e-commerce/add-product')));

// render - forms & tables
const FormsValidation = Loadable(lazy(() => import('pages/forms/validation')));
const FormsWizard = Loadable(lazy(() => import('pages/forms/wizard')));

const FormsLayoutBasic = Loadable(lazy(() => import('pages/forms/layouts/basic')));
const FormsLayoutMultiColumn = Loadable(lazy(() => import('pages/forms/layouts/multi-column')));
const FormsLayoutActionBar = Loadable(lazy(() => import('pages/forms/layouts/action-bar')));
const FormsLayoutStickyBar = Loadable(lazy(() => import('pages/forms/layouts/sticky-bar')));

const FormsPluginsMask = Loadable(lazy(() => import('pages/forms/plugins/mask')));
const FormsPluginsClipboard = Loadable(lazy(() => import('pages/forms/plugins/clipboard')));
const FormsPluginsRecaptcha = Loadable(lazy(() => import('pages/forms/plugins/re-captcha')));
const FormsPluginsEditor = Loadable(lazy(() => import('pages/cms/editor')));
const FormsPluginsDropzone = Loadable(lazy(() => import('pages/forms/plugins/dropzone')));

const ReactTableBasic = Loadable(lazy(() => import('pages/tables/react-table/basic')));
const ReactTableSorting = Loadable(lazy(() => import('pages/tables/react-table/sorting')));
const ReactTableFiltering = Loadable(lazy(() => import('pages/tables/react-table/filtering')));
const ReactTableGrouping = Loadable(lazy(() => import('pages/tables/react-table/grouping')));
const ReactTablePagination = Loadable(lazy(() => import('pages/tables/react-table/pagination')));
const ReactTableRowSelection = Loadable(lazy(() => import('pages/tables/react-table/row-selection')));
const ReactTableExpanding = Loadable(lazy(() => import('pages/tables/react-table/expanding')));
const ReactTableEditable = Loadable(lazy(() => import('pages/tables/react-table/editable')));
const ReactTableDragDrop = Loadable(lazy(() => import('pages/tables/react-table/drag-drop')));
const ReactTableColumnHiding = Loadable(lazy(() => import('pages/tables/react-table/column-hiding')));
const ReactTableColumnResizing = Loadable(lazy(() => import('pages/tables/react-table/column-resizing')));
const ReactTableStickyTable = Loadable(lazy(() => import('pages/tables/react-table/sticky')));
const ReactTableUmbrella = Loadable(lazy(() => import('pages/tables/react-table/umbrella')));
const ReactTableEmpty = Loadable(lazy(() => import('pages/tables/react-table/empty')));

// render - charts & map
const ChartApexchart = Loadable(lazy(() => import('pages/charts/apexchart')));
const ChartOrganization = Loadable(lazy(() => import('pages/charts/org-chart')));

// table routing
const MuiTableBasic = Loadable(lazy(() => import('pages/tables/mui-table/basic')));
const MuiTableDense = Loadable(lazy(() => import('pages/tables/mui-table/dense')));
const MuiTableEnhanced = Loadable(lazy(() => import('pages/tables/mui-table/enhanced')));
const MuiTableDatatable = Loadable(lazy(() => import('pages/tables/mui-table/datatable')));
const MuiTableCustom = Loadable(lazy(() => import('pages/tables/mui-table/custom')));
const MuiTableFixedHeader = Loadable(lazy(() => import('pages/tables/mui-table/fixed-header')));
const MuiTableCollapse = Loadable(lazy(() => import('pages/tables/mui-table/collapse')));

// pages routing
const AuthLogin = Loadable(lazy(() => import('pages/auth/auth1/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/auth1/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth1/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth1/reset-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth1/check-mail')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth1/code-verification')));

const AuthLogin2 = Loadable(lazy(() => import('pages/auth/auth2/login2')));
const AuthRegister2 = Loadable(lazy(() => import('pages/auth/auth2/register2')));
const AuthForgotPassword2 = Loadable(lazy(() => import('pages/auth/auth2/forgot-password2')));
const AuthResetPassword2 = Loadable(lazy(() => import('pages/auth/auth2/reset-password2')));
const AuthCheckMail2 = Loadable(lazy(() => import('pages/auth/auth2/check-mail2')));
const AuthCodeVerification2 = Loadable(lazy(() => import('pages/auth/auth2/code-verification2')));

const AuthLogin3 = Loadable(lazy(() => import('pages/auth/auth3/login3')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/error/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/error/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction')));
const MaintenanceUnderConstruction2 = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction2')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon2')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const Landing = Loadable(lazy(() => import('pages/landing')));
const ContactUS = Loadable(lazy(() => import('pages/contact-us')));
const PricingPage = Loadable(lazy(() => import('pages/extra-pages/price/price1')));
const PricingPage2 = Loadable(lazy(() => import('pages/extra-pages/price/price2')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />
          // children: [
          //   {
          //     path: 'default',
          //     element: <DashboardDefault />
          //   },
          //   {
          //     path: 'analytics',
          //     element: <DashboardAnalytics />
          //   }
          // ]
        },
        {
          path: 'sub-admin',
          children: [
            {
              path: '',
              element: <SubAdmin />
            },
            {
              path: 'manage',
              element: <AddEditSubAdmin />
            }
          ]
        },
        {
          path: 'vendor',
          children: [
            {
              path: '',
              element: <Vendor />
            },
            {
              path: 'manage',
              element: <AddEditVendor />
            }
          ]
        },
        {
          path: 'franchise',
          // element: <Franchise />,
          children: [
            {
              path: '',
              element: <Franchise />
            },
            {
              path: 'manage',
              element: <AddEditFranchise />
            }
          ]
        },
        {
          path: 'request',
          children: [
            {
              path: '',
              element: <Request />
            },
            {
              path: 'return-request',
              element: <ReturnRequest />
            }
          ]
        },
        {
          path: 'wheelz',
          children: [
            {
              path: '',
              element: <Wheelz />
            },
            {
              path: 'manage',
              element: <AddEditWheelz />
            }
          ]
        },
        {
          path: 'return',
          children: [
            {
              path: '',
              element: <Reason />
            },
            {
              path: 'manage',
              element: <AddEditReason />
            }
          ]
        },
        {
          path: 'checklist',
          children: [
            {
              path: '',
              element: <Checklist />
            },
            {
              path: 'manage',
              element: <AddEditChecklist />
            }
          ]
        },
        {
          path: 'faq',
          children: [
            {
              path: '',
              element: <FAQ />
            },
            {
              path: 'manage',
              element: <AddEditFAQ />
            }
          ]
        },
        {
          path: 'earnings',
          children: [
            {
              path: '',
              element: <Earnings />
            },
            {
              path: 'partners-earnings',
              element: <PartnersEarnings />
            }
          ]
        },
        {
          path: 'order',
          element: <Order />
        },
        {
          path: 'order/return',
          element: <Return />
        },
        {
          path: 'cms',
          element: <FormsPluginsEditor />
        },
        {
          path: 'customer',
          children: [
            {
              path: '',
              element: <AppCustomerList />
            },
            {
              path: 'customer-card',
              element: <AppCustomerCard />
            },
            {
              path: 'edit-customer',
              element: <AppCustomerEdit />
            }
          ]
        },
        {
          path: 'widget',
          children: [
            {
              path: 'statistics',
              element: <WidgetStatistics />
            },
            // {
            //   path: 'data',
            //   element: <WidgetData />
            // },
            {
              path: 'chart',
              element: <WidgetChart />
            }
          ]
        },
        {
          path: 'profile',
          children: [
            {
              path: '',
              element: <AccountTabAccount />
            },
            {
              path: 'change-password',
              element: <AccountTabPassword />
            }
          ]
        },
        {
          path: 'product',
          children: [
            {
              path: '',
              element: <AppECommProductList />
            }
          ]
        },
        {
          path: 'apps',
          children: [
            {
              path: 'chat',
              element: <AppChat />
            },
            {
              path: 'calendar',
              element: <AppCalendar />
            },
            {
              path: 'kanban',
              element: <AppKanban />,
              children: [
                {
                  path: 'backlogs',
                  element: <AppKanbanBacklogs />
                },
                {
                  path: 'board',
                  element: <AppKanbanBoard />
                }
              ]
            },
            {
              path: 'invoice',
              children: [
                {
                  path: 'dashboard',
                  element: <AppInvoiceDashboard />
                },
                {
                  path: 'create',
                  element: <AppInvoiceCreate />
                },
                {
                  path: 'details/:id',
                  element: <AppInvoiceDetails />
                },
                {
                  path: 'edit/:id',
                  element: <AppInvoiceEdit />
                },
                {
                  path: 'list',
                  element: <AppInvoiceList />
                }
              ]
            },
            {
              path: 'profiles',
              children: [
                {
                  path: 'account',
                  element: <AccountProfile />,
                  children: [
                    {
                      path: 'basic',
                      element: <AccountTabProfile />
                    },
                    {
                      path: 'personal',
                      element: <AccountTabPersonal />
                    },
                    // {
                    //   path: 'my-account',
                    //   element: <AccountTabAccount />
                    // },
                    // {
                    //   path: 'password',
                    //   element: <AccountTabPassword />
                    // },
                    {
                      path: 'role',
                      element: <AccountTabRole />
                    },
                    {
                      path: 'settings',
                      element: <AccountTabSettings />
                    }
                  ]
                },
                {
                  path: 'user',
                  element: <UserProfile />,
                  children: [
                    {
                      path: 'personal',
                      element: <UserTabPersonal />
                    },
                    {
                      path: 'payment',
                      element: <UserTabPayment />
                    },
                    {
                      path: 'password',
                      element: <UserTabPassword />
                    },
                    {
                      path: 'settings',
                      element: <UserTabSettings />
                    }
                  ]
                }
              ]
            },
            {
              path: 'category',
              element: <ProductCategory />
            },
            {
              path: 'add-category',
              element: <ProductAddCategory />
            },
            {
              path: 'subcategory',
              element: <ProductSubcategory />
            },
            {
              path: 'add-subcategory',
              element: <ProductAddSubcategory />
            },
            {
              path: 'product-type',
              element: <ProductType />
            },
            {
              path: 'add-productType',
              element: <AddProductType />
            },
            {
              path: 'variant',
              element: <Variant />
            },
            {
              path: 'add-variant',
              element: <AddVariant />
            },
            {
              path: 'variant-value',
              element: <VariantValue />
            },
            {
              path: 'add-variant-value',
              element: <AddVariantValue />
            },
            {
              path: 'state',
              element: <State />
            },
            {
              path: 'add-state',
              element: <AddState />
            },
            {
              path: 'city',
              element: <City />
            },
            {
              path: 'add-city',
              element: <AddCity />
            },
            {
              path: 'charges',
              children: [
                {
                  path: '',
                  element: <Charges />
                },
                {
                  path: 'manage',
                  element: <AddCharge />
                }
              ]
            },
            {
              path: 'taxes',
              children: [
                {
                  path: 'list-tax',
                  element: <Taxes />
                },
                {
                  path: 'add-tax',
                  element: <AddTax />
                }
              ]
            },
            {
              path: 'notifications',
              children: [
                {
                  path: '',
                  element: <Notifications />
                }
              ]
            },
            {
              path: 'e-commerce',
              children: [
                {
                  path: 'products',
                  element: <AppECommProducts />
                },
                {
                  path: 'product-details/:id',
                  element: <AppECommProductDetails />
                }
                // {
                //   path: 'product-list',
                //   element: <AppECommProductList />
                // }
                // {
                //   path: 'add-new-product',
                //   element: <AppECommAddProduct />
                // },
                // {
                //   path: 'checkout',
                //   element: <AppECommCheckout />
                // }
              ]
            }
          ]
        },
        {
          path: 'forms',
          children: [
            {
              path: 'validation',
              element: <FormsValidation />
            },
            {
              path: 'wizard',
              element: <FormsWizard />
            },
            {
              path: 'layout',
              children: [
                {
                  path: 'basic',
                  element: <FormsLayoutBasic />
                },
                {
                  path: 'multi-column',
                  element: <FormsLayoutMultiColumn />
                },
                {
                  path: 'action-bar',
                  element: <FormsLayoutActionBar />
                },
                {
                  path: 'sticky-bar',
                  element: <FormsLayoutStickyBar />
                }
              ]
            },
            {
              path: 'plugins',
              children: [
                {
                  path: 'mask',
                  element: <FormsPluginsMask />
                },
                {
                  path: 'clipboard',
                  element: <FormsPluginsClipboard />
                },
                {
                  path: 're-captcha',
                  element: <FormsPluginsRecaptcha />
                },
                // {
                //   path: 'editor',
                //   element: <FormsPluginsEditor />
                // },
                {
                  path: 'dropzone',
                  element: <FormsPluginsDropzone />
                }
              ]
            }
          ]
        },
        {
          path: 'tables',
          children: [
            {
              path: 'react-table',
              children: [
                {
                  path: 'basic',
                  element: <ReactTableBasic />
                },
                {
                  path: 'sorting',
                  element: <ReactTableSorting />
                },
                {
                  path: 'filtering',
                  element: <ReactTableFiltering />
                },
                {
                  path: 'grouping',
                  element: <ReactTableGrouping />
                },
                {
                  path: 'pagination',
                  element: <ReactTablePagination />
                },
                {
                  path: 'row-selection',
                  element: <ReactTableRowSelection />
                },
                {
                  path: 'expanding',
                  element: <ReactTableExpanding />
                },
                {
                  path: 'editable',
                  element: <ReactTableEditable />
                },
                {
                  path: 'drag-drop',
                  element: <ReactTableDragDrop />
                },
                {
                  path: 'column-hiding',
                  element: <ReactTableColumnHiding />
                },
                {
                  path: 'column-resizing',
                  element: <ReactTableColumnResizing />
                },
                {
                  path: 'sticky-table',
                  element: <ReactTableStickyTable />
                },
                {
                  path: 'umbrella',
                  element: <ReactTableUmbrella />
                },
                {
                  path: 'empty',
                  element: <ReactTableEmpty />
                }
              ]
            },
            {
              path: 'mui-table',
              children: [
                {
                  path: 'basic',
                  element: <MuiTableBasic />
                },
                {
                  path: 'dense',
                  element: <MuiTableDense />
                },
                {
                  path: 'enhanced',
                  element: <MuiTableEnhanced />
                },
                {
                  path: 'datatable',
                  element: <MuiTableDatatable />
                },
                {
                  path: 'custom',
                  element: <MuiTableCustom />
                },
                {
                  path: 'fixed-header',
                  element: <MuiTableFixedHeader />
                },
                {
                  path: 'collapse',
                  element: <MuiTableCollapse />
                }
              ]
            }
          ]
        },
        {
          path: 'charts',
          children: [
            {
              path: 'apexchart',
              element: <ChartApexchart />
            },
            {
              path: 'org-chart',
              element: <ChartOrganization />
            }
          ]
        },
        {
          path: 'sample-page',
          element: <SamplePage />
        },
        {
          path: 'price',
          children: [
            {
              path: 'price1',
              element: <PricingPage />
            },
            {
              path: 'price2',
              element: <PricingPage2 />
            }
          ]
        }
      ]
    },
    {
      path: '/',
      element: <CommonLayout layout="landing" />,
      children: [
        {
          path: 'landing',
          element: <Landing />
        }
      ]
    },
    {
      path: '/',
      element: <CommonLayout layout="simple" />,
      children: [
        {
          path: 'contact-us',
          element: <ContactUS />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'under-construction2',
          element: <MaintenanceUnderConstruction2 />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        },
        {
          path: 'coming-soon2',
          element: <MaintenanceComingSoon2 />
        }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'login2',
          element: <AuthLogin2 />
        },
        {
          path: 'register2',
          element: <AuthRegister2 />
        },
        {
          path: 'forgot-password2',
          element: <AuthForgotPassword2 />
        },
        {
          path: 'reset-password2',
          element: <AuthResetPassword2 />
        },
        {
          path: 'check-mail2',
          element: <AuthCheckMail2 />
        },
        {
          path: 'code-verification2',
          element: <AuthCodeVerification2 />
        },
        {
          path: 'login3',
          element: <AuthLogin3 />
        }
      ]
    }
  ]
};

export default MainRoutes;
